import { useRouteError } from "react-router-dom";

const ErrorPage = () => {
    const error = useRouteError();

    console.error(error);

    return (
        <div className="mt-[-96px] w-full h-screen text-center text-white flex flex-col justify-center">
            <h1 className="text-3xl md:text-4xl p-2"> Sorry 😅</h1>
            <h1 className="text-2xl md:text-3xl p-2">An unexpected error has occurred:</h1>
            <p className="text-1xl md:text-2xl">
                {(error.status).toString() + ' ' + error.statusText}
            </p>
        </div>
    )
};

export default ErrorPage;